import React, { Component } from 'react'

export default class Form extends Component {
  render() {
    return (
      <div>Form</div>
    )
  }
}
